<div class="tt-c-summary-dim tt-c-summary-dim-select-image tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading tt-u-align-center" role="heading" :aria-level="headingLevel">{{label}}</div>
  <div class="tt-c-summary-dim-select-image__images tt-u-align-center">
    <span v-for="item in values" class="tt-c-summary-dim-select-image__image-count">
      <img class="tt-c-summary-dim-select-image__image" :src="imageUrl(item.imageId)">
      <span class="tt-c-summary-dim-select-image__count tt-c-summary-dim__text">{{item.count}}</span>
    </span>
  </div>
</div>
